var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style.small] = _vm.kind === 'small', _obj ), ( _obj$1 = {}, _obj$1[_vm.$style.empty] = _vm.kind === 'empty', _obj$1 ) ]},[(_vm.kind !== 'empty')?_c('h1',{class:[_vm.$style.heading, ( _obj$2 = {}, _obj$2[_vm.$style.smallHeading] = _vm.kind === 'small', _obj$2 ) ]},[_vm._t("default")],2):_vm._e()])
var _obj;
var _obj$1;
var _obj$2;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fbea136","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hero.vue
// module id = null
// module chunks = 